import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import type { AppKitNetwork } from '@reown/appkit/networks'
import { http } from 'viem'
import { APP_DISPLAY_NAME, env, getPublicAppOrigin } from '@/config/env.ts'
import { getChainOrDefault, getDefaultRpcUrl } from '@/config/chains.ts'

// Project ID from https://cloud.reown.com — add your app URL (e.g. http://localhost:5173) under
// "Allowed origins" in the project settings to avoid 403 on config/project-limits fetches.
const projectId = env.reownProjectId

const metadata = {
  name: APP_DISPLAY_NAME,
  description: 'The Custodian of Your Digital Legacy',
  url: getPublicAppOrigin(),
  icons: ['/bitslegacy_logo.png'],
}

// The active chain is fully driven by `VITE_CHAIN_ID`. Switching the app to a
// different network (Sepolia → Amoy → Polygon mainnet → …) is purely an env
// change; no code edits required as long as the chain is registered in
// `src/config/chains.ts`.
const activeChain = getChainOrDefault(env.chainId)

const networks: [AppKitNetwork, ...AppKitNetwork[]] = [
  activeChain as AppKitNetwork,
]

const rpcUrl = env.rpcUrl || getDefaultRpcUrl(activeChain.id) || undefined

const transports: Record<number, ReturnType<typeof http>> = {
  [activeChain.id]: http(rpcUrl),
}

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  transports,
})

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  allowUnsupportedChain: true,
  enableNetworkSwitch: false,
  features: {
    analytics: env.enableAnalytics,
    email: false,
    socials: [],
    swaps: false,
    onramp: false,
  },
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#c9a84c',
    '--w3m-color-mix': '#09090b',
    '--w3m-color-mix-strength': 40,
    '--w3m-border-radius-master': '2px',
  },
})
